// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'

Vue.config.productionTip = false
Vue.use(ElementUI)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  method: {
    submitForm () {
      console.log('zwy' + 1)
      axios
        .post('')
        .catch(error => {
          console.log('zwy' + error)
        })
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js